export default __webpack_public_path__ + "static/media/about2.20ed1f2a.svg";